import { render, staticRenderFns } from "./primerCompra.vue?vue&type=template&id=5a070acb&scoped=true"
import script from "./primerCompra.vue?vue&type=script&lang=js"
export * from "./primerCompra.vue?vue&type=script&lang=js"
import style0 from "./primerCompra.vue?vue&type=style&index=0&id=5a070acb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a070acb",
  null
  
)

export default component.exports